module.exports = __webpack_public_path__ + "img/chest_hover.0458f6ca.png";